var $ef974ff21ee4e13f$exports = {};
$ef974ff21ee4e13f$exports = {
    "clear": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{434}\u{456}\u{439}\u{441}\u{43D}\u{435})`,
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}...`,
    "noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{456}\u{432} \u{43D}\u{435}\u{43C}\u{430}\u{454}`,
    "valid": `(\u{434}\u{456}\u{439}\u{441}\u{43D}\u{438}\u{439})`
};


export {$ef974ff21ee4e13f$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
